'use client';

import React, { createContext, useContext } from 'react';

export interface OpsLabels {
  status?: Record<string, string>;
  signal?: Record<string, string>;
  density?: Record<string, string>;
  actions?: Record<string, string>;
  [key: string]: Record<string, string> | undefined;
}

const LabelsContext = createContext<OpsLabels>({});

export function LabelsProvider({
  labels = {},
  children,
}: {
  labels?: OpsLabels;
  children: React.ReactNode;
}) {
  return <LabelsContext.Provider value={labels}>{children}</LabelsContext.Provider>;
}

export function useLabels(): OpsLabels {
  return useContext(LabelsContext);
}
